import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { ActivityIndicatorsViewModel } from './activity-indicators.model';
export class ActivityIndicatorsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ActivityIndicatorsConfiguration';
  nodataLocalizationKeyName = 'bnyActivityIndicators';
  readonly reportSection = ReportSection.ActivityIndicators;
  readonly name = 'activityIndicators';
  readonly displayName = 'DR Activity Indicators';
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_ActivityIndicators];
  minSize = 2;
  maxSize = 4;
  defaultSize = 2;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'activityIndicatorGridForMonth',
      displayName: 'For The Month Of',
      type: ReportSectionConfigurationControlType.Custom,
      isSelected: true,
      canConfigure: true,
      allowUnselectAll: true,
      subSections: [
        {
          name: 'dRPrice',
          displayName: 'DR Price',
          isSelected: true,
          canConfigure: true,
          groupName: 'row'
        },
        {
          name: 'snpFiveHundred',
          displayName: 'S&P 500',
          isSelected: true,
          canConfigure: true,
          groupName: 'row'
        },
        {
          name: 'aDRIndex',
          displayName: 'ADR Composite Index',
          isSelected: true,
          canConfigure: true,
          groupName: 'row'
        },
        {
          name: 'dailyDRTradingUSD',
          displayName: 'Daily DR Trading, USD',
          isSelected: true,
          canConfigure: true,
          groupName: 'column'
        },
        {
          name: 'dailyDRTrading',
          displayName: 'Daily DR Trading',
          isSelected: true,
          canConfigure: true,
          groupName: 'column'
        }
      ]
    },
    {
      name: 'activityIndicatorGridForPeriod',
      displayName: 'Period Of',
      type: ReportSectionConfigurationControlType.Custom,
      isSelected: true,
      canConfigure: true,
      allowUnselectAll: true,
      subSections: [
        {
          name: 'periodDRPrice',
          displayName: 'DR Price',
          isSelected: true,
          canConfigure: true,
          groupName: 'row'
        },
        {
          name: 'periodSnpFiveHundred',
          displayName: 'S&P 500',
          isSelected: true,
          canConfigure: true,
          groupName: 'row'
        },
        {
          name: 'periodADRIndex',
          displayName: 'ADR Composite Index',
          isSelected: true,
          canConfigure: true,
          groupName: 'row'
        },
        {
          name: 'periodDailyDRTradingUSD',
          displayName: 'Daily DR Trading, USD',
          isSelected: true,
          canConfigure: true,
          groupName: 'column'
        },
        {
          name: 'periodDailyDRTrading',
          displayName: 'Daily DR Trading',
          isSelected: true,
          canConfigure: true,
          groupName: 'column'
        }
      ]
    }
  ];
}

export interface DrDataItem {
  month: string;
  value: number;
}

export interface ActivityIndicators {
  [ReportViewModelSection.BnyManagementReport_ActivityIndicators]: ActivityIndicatorsViewModel;
}

export interface TableColumn {
  label: string;
  type: string;
}

export type TableRowValue = number | string | { value: number; month: string };

export interface TableRow {
  label: string;
  values: Record<string, TableRowValue>;
}

export interface TableDefinition {
  title: string;
  titleParams?: Record<string, string>;
  columns: TableColumn[];
  rows: TableRow[];
}
